export default function TitleCustom({
  icon,
  children,
  color = 'var(--color-on-Base-Content-High, #263146)',
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        color,
        fontSize: '20px',
        fontWeight: 500,
      }}
    >
      {icon && (
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: 24, // ปรับขนาด icon ได้
          }}
        >
          {icon}
        </span>
      )}
      <span>{children}</span>
    </div>
  )
}
